/**
 * File for production configuration
 */

export const environment = {
    production: true,
    configFile: 'config.json',
};
